"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunQueryButton = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ui_1 = require("@grafana/ui");
const RunQueryButton = ({ ariaLabel = 'Query editor Run button', queryRunning = false, queryInvalid = false, invalidQueryTooltip, disabled = false, onClick, dataTestId, }) => {
    let icon = queryInvalid ? 'exclamation-triangle' : undefined;
    if (queryRunning) {
        icon = 'fa fa-spinner';
    }
    const RunButton = (react_1.default.createElement(ui_1.Button, { "aria-label": ariaLabel, size: "sm", variant: "secondary", icon: icon, disabled: disabled || queryRunning, onClick: onClick, "data-testid": dataTestId }, "Run query"));
    return queryInvalid ? (react_1.default.createElement(ui_1.Tooltip, { theme: "error", placement: "top", content: invalidQueryTooltip !== null && invalidQueryTooltip !== void 0 ? invalidQueryTooltip : (react_1.default.createElement(react_1.default.Fragment, null,
            "Your query is invalid. Check below for details. ",
            react_1.default.createElement("br", null),
            "However, you can still run this query.")) }, RunButton)) : (RunButton);
};
exports.RunQueryButton = RunQueryButton;
//# sourceMappingURL=RunQueryButton.js.map